import { __decorate } from "tslib";
import { LitElement } from 'lit';
import { html, literal } from 'lit/static-html.js';
import { property, query } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './arc-icon-button.styles.js';
import '../icon/arc-icon.js';
import '../spinner/arc-spinner.js';
export default class ArcIconButton extends LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.active = false;
        this.disabled = false;
        this.loading = false;
    }
    click() {
        this.button.click();
    }
    focus(options) {
        this.button.focus(options);
    }
    blur() {
        this.button.blur();
    }
    _handleClick(event) {
        if (this.disabled || this.loading) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    render() {
        const isLink = !!this.href;
        const tag = isLink ? literal `a` : literal `button`;
        return html `
      <${tag}
        id="main"
        class=${classMap({
            button: true,
            'button--active': this.active,
            'button--disabled': this.disabled,
            'button--loading': this.loading,
        })}
        ?disabled=${ifDefined(isLink ? undefined : this.disabled)}
        type="button"
        href=${ifDefined(this.href || undefined)}
        target=${ifDefined(this.target || undefined)}
        download=${ifDefined(this.download || undefined)}
        rel=${ifDefined(this.target ? 'noreferrer noopener' : undefined)}
        role="button"
        aria-disabled=${this.disabled ? 'true' : 'false'}
        aria-label=${this.label}
        tabindex=${this.disabled ? '-1' : '0'}
        @click=${this._handleClick}
      >
        <span id="iconWrapper" aria-hidden="true">
          <arc-icon id="icon" part="icon" name=${ifDefined(this.name || undefined)}></arc-icon>
          ${when(this.loading, () => html `<arc-spinner id="loader"></arc-spinner>`)}
        </span>
        <span id="action"><slot></slot></span>
      </${tag}>
    `;
    }
}
ArcIconButton.tag = 'arc-icon-button';
ArcIconButton.styles = styles;
__decorate([
    query('#main')
], ArcIconButton.prototype, "button", void 0);
__decorate([
    property({ type: String })
], ArcIconButton.prototype, "name", void 0);
__decorate([
    property({ type: String })
], ArcIconButton.prototype, "href", void 0);
__decorate([
    property({ type: String })
], ArcIconButton.prototype, "target", void 0);
__decorate([
    property({ type: String })
], ArcIconButton.prototype, "download", void 0);
__decorate([
    property({ type: String })
], ArcIconButton.prototype, "label", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ArcIconButton.prototype, "active", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ArcIconButton.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ArcIconButton.prototype, "loading", void 0);
